import { env } from "../env";

export const APPLE_APP_STORE_LINK =
  "https://apps.apple.com/de/app/e-bike-sharing/id6743134666";

export const GOOGLE_PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=eu.usegroup.app";

type AppLinkSearchParams = Record<string, string | null | undefined>;

/**
 * Builds a verified Universal/App Link on the dedicated handoff origin.
 * Keeping this origin separate from the embedded page gives host WebViews an
 * external navigation that the operating system can route to the native app.
 */
export function getAppLink(
  pathname: string,
  searchParams: AppLinkSearchParams = {},
): string {
  const url = new URL(pathname, env.universalLinkScheme);

  for (const [key, value] of Object.entries(searchParams)) {
    if (value) {
      url.searchParams.set(key, value);
    }
  }

  return url.toString();
}
